import { useEffect, useState } from "preact/hooks";

export function Footer() {
  const year = new Date().getFullYear();
  const [commit, setCommit] = useState<string | null>(null);

  useEffect(() => {
    fetch("/api/version")
      .then((r) => (r.ok ? r.json() : null))
      .then((data) => {
        if (data?.commit && data.commit !== "dev") {
          setCommit(data.commit);
        }
      })
      .catch(() => {
        // best-effort; footer works without it
      });
  }, []);

  return (
    <footer class="border-top py-3 mt-auto">
      <div class="container">
        <p class="text-center text-muted small mb-2">
          &copy; {year} MyPortal &middot;{" "}
          <a href="/legal/terms" class="text-muted text-decoration-none">
            Terms
          </a>{" "}
          &middot;{" "}
          <a href="/legal/privacy" class="text-muted text-decoration-none">
            Privacy
          </a>{" "}
          &middot;{" "}
          <a href="/legal/refund" class="text-muted text-decoration-none">
            Refunds
          </a>{" "}
          &middot;{" "}
          <a
            href="/legal/acceptable-use"
            class="text-muted text-decoration-none"
          >
            Acceptable Use
          </a>
        </p>
        {commit && (
          <p class="text-center text-muted small mb-0 font-monospace">
            {commit}
          </p>
        )}
      </div>
    </footer>
  );
}
